// import React, { useCallback, useContext, useEffect, useState } from 'react'
// import { useNavigate, useParams } from 'react-router-dom'
// import { summaryApi } from '../../common'
// import { displayNGNCurrency } from '../../helpers/displayCurrency'
// import { FaStar, FaRegStar, FaTrash, FaEdit } from "react-icons/fa";
// import { MdOutlineRateReview } from "react-icons/md";
// import { toast } from 'react-toastify';
// import CategoryProductDisplay from '../../components/CategoryProductDisplay/CategoryProductDisplay';
// import Context from '../../context';
// import addToCart from '../../helpers/addToCart';
// import { useTheme } from '../../components/Theme/ThemeProvider';
// import { ShoppingCart, Heart, Star, Check } from 'lucide-react';

// function ProductDetails() {
//   const { colors } = useTheme();
//   const [dataDetails, setDataDetails] = useState({
//     productName: "",
//     productPrice: "",
//     productsCategory: "",
//     productDescription: "",
//     productImage: [],
//     productBrand: "",
//     productDiscount: "",
//     storage: "",
//     color: "",
//     ram: "",
//     processor: "",
//     screenSize: ""
//   })

//   const params = useParams()
//   const [loading, setLoading] = useState(false);
//   const [activeImage, setActiveImage] = useState("")
//   const [review, setReview] = useState("");
//   const [rating, setRating] = useState(0);
//   const [reviews, setReviews] = useState([]);
//   const [editingReview, setEditingReview] = useState(null);
//   const [currentUser, setCurrentUser] = useState(null);
//   const [isZoomed, setIsZoomed] = useState(false);
//   const [zoomOpen, setZoomOpen] = useState(false)
//   const [zoomImage, setZoomImage] = useState({
//     x: 0,
//     y: 0
//   })

//   // New state for product variants
//   const [selectedOptions, setSelectedOptions] = useState({
//     storage: '',
//     color: '',
//     ram: '',
//     processor: '',
//     screenSize: ''
//   })

//   const { fetchUserAddToCart } = useContext(Context)
//   const navigate = useNavigate()

//   const productImageListLoading = new Array(4).fill(null)

//   const fetchCurrentUser = async () => {
//     try {
//       const response = await fetch(summaryApi.current_user.url, {
//         method: summaryApi.current_user.method,
//         credentials: 'include'
//       });
//       const data = await response.json();
//       setCurrentUser(data?.data);
//     } catch (error) {
//       console.error("Error fetching user details:", error);
//     }
//   }

//   const fetchProductDetails = async () => {
//     setLoading(true)
//     const response = await fetch(`${summaryApi.productDetails.url}/${params?.id}`, {
//       method: summaryApi.productDetails.method,
//       credentials: "include",
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     })
//     setLoading(false)
//     const responseData = await response.json()

//     setDataDetails(responseData.data)
//     setActiveImage(responseData.data.productImage[0])
    
//     // Initialize selected options with available values
//     if (responseData.data) {
//       setSelectedOptions({
//         storage: responseData.data.storage || '',
//         color: responseData.data.color || '',
//         ram: responseData.data.ram || '',
//         processor: responseData.data.processor || '',
//         screenSize: responseData.data.screenSize || ''
//       })
//     }
//   }

//   const fetchProductReviews = async () => {
//     try {
//       const response = await fetch(`${summaryApi.getReviews.url}/${params?.id}`, {
//         method: summaryApi.getReviews.method,
//         credentials: 'include'
//       });
//       const data = await response.json();
//       setReviews(data.data || []);
//     } catch (error) {
//       console.error("Error fetching reviews:", error);
//     }
//   }

//   useEffect(() => {
//     const fetchData = async () => {
//       await fetchProductDetails();
//       await fetchProductReviews();
//       await fetchCurrentUser();
//     };
//     fetchData();
//   }, [params.id]);

//   const handleImageHover = (image) => {
//     setActiveImage(image)
//   }

//   const handleOptionSelect = (optionType, value) => {
//     setSelectedOptions(prev => ({
//       ...prev,
//       [optionType]: value
//     }))
//   }

//   // Helper function to parse comma-separated values into arrays
//   const parseOptions = (value) => {
//     if (!value) return [];
//     return value.split(',').map(item => item.trim()).filter(item => item);
//   }

//   const handleSubmitReview = async (e) => {
//     e.preventDefault();
//     if (review.trim() && rating > 0) {
//       try {
//         const reviewData = {
//           rating: rating,
//           comment: review
//         };

//         const response = await fetch(`${summaryApi.postReview.url}/${params?.id}`, {
//           method: summaryApi.postReview.method,
//           credentials: 'include',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(reviewData)
//         });

//         const responseText = await response.text();

//         try {
//           const data = JSON.parse(responseText);
//           if (data.success) {
//             fetchProductReviews();
//             setReview("");
//             setRating(0);
//             toast.success(data.message)
//           } else {
//             toast.error(data.message || "Failed to post review");
//           }
//         } catch (parseError) {
//           console.error("Error parsing response:", parseError);
//           toast.error("Error processing server response");
//         }
//       } catch (error) {
//         console.error("Error posting review:", error);
//         toast.error("Failed to submit review");
//       }
//     }
//   }

//   const startEditReview = (review) => {
//     setEditingReview(review);
//     setReview(review.comment);
//     setRating(review.rating);
//   }

//   const handleUpdateReview = async (e) => {
//     e.preventDefault();
//     if (review.trim() && rating > 0) {
//       try {
//         const updateData = {
//           reviewId: editingReview._id,
//           userId: currentUser._id,
//           rating: rating,
//           comment: review
//         };

//         const response = await fetch(`${summaryApi.updateReview.url}/${params.id}`, {
//           method: summaryApi.updateReview.method,
//           credentials: 'include',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(updateData)
//         });

//         const data = await response.json();
//         if (data.success) {
//           fetchProductReviews();
//           setReview("");
//           setRating(0);
//           setEditingReview(null);
//           toast.success('Review updated successfully');
//         }
//       } catch (error) {
//         console.error("Error updating review:", error);
//         toast.error('Failed to update review');
//       }
//     }
//   }

//   const handleDeleteReview = async (reviewId) => {
//     try {
//       const deleteData = {
//         reviewId: reviewId,
//         userId: currentUser._id
//       };

//       const response = await fetch(`${summaryApi.deleteReview.url}/${params.id}`, {
//         method: summaryApi.deleteReview.method,
//         credentials: 'include',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(deleteData)
//       });

//       const data = await response.json();
//       if (data.success) {
//         fetchProductReviews();
//         toast.success('Review deleted successfully');
//       }
//     } catch (error) {
//       console.error("Error deleting review:", error);
//       toast.error('Failed to delete review');
//     }
//   }

//   const renderStarRating = (currentRating, setRatingFunc) => {
//     return [1, 2, 3, 4, 5].map((star) => (
//       <span
//         key={star}
//         onClick={() => setRatingFunc(star)}
//         className="cursor-pointer text-2xl transition-transform hover:scale-110"
//         style={{ color: star <= currentRating ? colors.accent : colors.border }}
//       >
//         {star <= currentRating ? <FaStar /> : <FaRegStar />}
//       </span>
//     ));
//   }

//   const handleZoomEnter = () => {
//     setZoomOpen(true);
//     setIsZoomed(true);
//   };
  
//   const handleZoomLeave = () => {
//     setZoomOpen(false);
//     setIsZoomed(false);
//     setZoomImage({ x: 0, y: 0 });
//   };
  
//   const handleImageClick = () => {
//     setZoomOpen(prev => !prev);
//   };

//   const handleZoomImage = useCallback((e) => {
//     if (!isZoomed) return;

//     const { left, top, width, height } = e.target.getBoundingClientRect();

//     const x = ((e.clientX - left) / width) * 100;
//     const y = ((e.clientY - top) / height) * 100;

//     setZoomImage({
//       x,
//       y
//     });
//   }, [isZoomed]);

//   const handleAddToCart = (e, productId) => {
//     // Create proper cart data object
//     const cartData = {
//         productId: productId,
//         storage: selectedOptions.storage,
//         color: selectedOptions.color,
//         ram: selectedOptions.ram,
//         processor: selectedOptions.processor,
//         screenSize: selectedOptions.screenSize
//     };
    
//     addToCart(e, cartData, fetchUserAddToCart);
// }

// const handleBuyNow = async (e) => {  
//     const cartData = {
//         productId: dataDetails?._id,
//         storage: selectedOptions.storage,
//         color: selectedOptions.color,
//         ram: selectedOptions.ram,
//         processor: selectedOptions.processor,
//         screenSize: selectedOptions.screenSize
//     };
    
//     await addToCart(e, cartData, fetchUserAddToCart);  
//     navigate("/cart");
// }

//   const discountPercentage = Math.round((dataDetails.productDiscount / dataDetails.productPrice) * 100);
//   const averageRating = reviews.length > 0 
//     ? (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1)
//     : 0;

//   // Check if all required options are selected
//   const areAllOptionsSelected = () => {
//     const availableOptions = [
//       { field: 'storage', value: dataDetails.storage },
//       { field: 'color', value: dataDetails.color },
//       { field: 'ram', value: dataDetails.ram },
//       { field: 'processor', value: dataDetails.processor },
//       { field: 'screenSize', value: dataDetails.screenSize }
//     ].filter(option => option.value && option.value.trim() !== '');

//     return availableOptions.every(option => selectedOptions[option.field]);
//   }

//   return (
//     <div className='min-h-screen transition-colors duration-300 mt-20' style={{ backgroundColor: colors.bg }}>
//       <div className='container mx-auto p-4'>
//         <div className='min-h-[200px] flex flex-col lg:flex-row gap-8 mb-12'>
//           {/* Product Image Section */}
//           <div className='h-96 flex flex-col lg:flex-row-reverse gap-4'>
//             <div 
//               className='relative h-[300px] w-[300px] lg:h-96 lg:w-96 flex items-center justify-center rounded-lg overflow-hidden'
//               style={{ backgroundColor: colors.bgSecondary, border: `1px solid ${colors.border}` }}
//             >
//               {loading ? (
//                 <div className='animate-pulse w-full h-full' style={{ backgroundColor: colors.bgTertiary }}></div>
//               ) : (
//                 <img
//                   src={activeImage}
//                   alt={dataDetails.productName}
//                   className='h-full w-full object-scale-down p-4'
//                   onMouseEnter={handleZoomEnter}
//                   onMouseLeave={handleZoomLeave}
//                   onMouseMove={handleZoomImage}
//                   onClick={handleImageClick}
//                 />
//               )}
              
//               {zoomOpen && (
//                 <div
//                   className='hidden lg:block absolute min-w-[400px] min-h-[400px] overflow-hidden p-1 -right-[510px] top-0 rounded-lg'
//                   style={{ backgroundColor: colors.bgSecondary }}
//                 >
//                   <div
//                     className='w-full h-full min-h-[400px] min-w-[500px] scale-150'
//                     style={{
//                       backgroundImage: `url(${activeImage})`,
//                       backgroundSize: 'cover',
//                       backgroundPosition: `${zoomImage.x}% ${zoomImage.y}%`,
//                       backgroundRepeat: 'no-repeat'
//                     }}
//                   />
//                 </div>
//               )}
//             </div>

//             {/* Thumbnail Images */}
//             <div className='h-full'>
//               {loading ? (
//                 <div className='flex gap-2 lg:flex-col overflow-scroll scrollbar-none h-full'>
//                   {productImageListLoading.map((_, index) => (
//                     <div
//                       key={index}
//                       className='h-20 w-20 rounded animate-pulse'
//                       style={{ backgroundColor: colors.bgTertiary }}
//                     />
//                   ))}
//                 </div>
//               ) : (
//                 <div className='flex gap-2 lg:flex-col overflow-scroll scrollbar-none h-full'>
//                   {dataDetails?.productImage?.map((item, index) => (
//                     <div
//                       key={index}
//                       className='h-20 w-20 rounded p-1 cursor-pointer transition-all hover:scale-105'
//                       style={{ 
//                         backgroundColor: activeImage === item ? colors.primary : colors.bgSecondary,
//                         border: `2px solid ${activeImage === item ? colors.primary : colors.border}`
//                       }}
//                     >
//                       <img
//                         src={item}
//                         alt={dataDetails.productName}
//                         onMouseEnter={() => handleImageHover(item)}
//                         onClick={() => handleImageHover(item)}
//                         className='h-full w-full object-scale-down'
//                       />
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Product Details Section */}
//           {loading ? (
//             <div className='flex flex-col gap-4 w-full'>
//               {[...Array(5)].map((_, i) => (
//                 <div 
//                   key={i}
//                   className='h-8 rounded animate-pulse' 
//                   style={{ backgroundColor: colors.bgTertiary }}
//                 />
//               ))}
//             </div>
//           ) : (
//             <div className='flex flex-col gap-4 flex-1'>
//               {/* Brand Badge */}
//               <div
//                 className='inline-block px-4 py-2 rounded-full w-fit text-sm font-bold'
//                 style={{
//                   backgroundColor: colors.primaryLight,
//                   color: colors.primary
//                 }}
//               >
//                 Brand: {dataDetails?.productBrand}
//               </div>

//               {/* Product Name */}
//               <h1 
//                 className='text-3xl font-bold'
//                 style={{ color: colors.text }}
//               >
//                 {dataDetails?.productName}
//               </h1>

//               {/* Category */}
//               <p 
//                 className='text-sm capitalize'
//                 style={{ color: colors.textSecondary }}
//               >
//                 Category: {dataDetails?.productsCategory}
//               </p>

//               {/* Rating */}
//               <div className='flex items-center gap-3'>
//                 <div className='flex gap-1'>
//                   {[...Array(5)].map((_, i) => (
//                     <Star
//                       key={i}
//                       size={20}
//                       fill={i < Math.floor(averageRating) ? colors.accent : colors.border}
//                       style={{ color: i < Math.floor(averageRating) ? colors.accent : colors.border }}
//                     />
//                   ))}
//                 </div>
//                 <span style={{ color: colors.textSecondary }} className='text-sm'>
//                   ({averageRating}/5) • {reviews.length} reviews
//                 </span>
//               </div>

//               {/* Product Specifications Selection */}
//               <div className='space-y-4 my-4'>
//                 {/* Storage Options */}
//                 {dataDetails.storage && (
//                   <div>
//                     <label className='block text-sm font-semibold mb-2' style={{ color: colors.text }}>
//                       Storage
//                     </label>
//                     <div className='flex flex-wrap gap-2'>
//                       {parseOptions(dataDetails.storage).map((storageOption) => (
//                         <button
//                           key={storageOption}
//                           type='button'
//                           onClick={() => handleOptionSelect('storage', storageOption)}
//                           className={`px-4 py-2 rounded-lg font-medium transition-all ${
//                             selectedOptions.storage === storageOption 
//                               ? 'text-white' 
//                               : 'hover:scale-105'
//                           }`}
//                           style={{
//                             backgroundColor: selectedOptions.storage === storageOption 
//                               ? colors.primary 
//                               : colors.bgSecondary,
//                             color: selectedOptions.storage === storageOption 
//                               ? 'white' 
//                               : colors.text,
//                             border: `2px solid ${selectedOptions.storage === storageOption 
//                               ? colors.primary 
//                               : colors.border}`
//                           }}
//                         >
//                           {storageOption}
//                           {selectedOptions.storage === storageOption && (
//                             <Check size={16} className='inline ml-1' />
//                           )}
//                         </button>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {/* Color Options */}
//                 {dataDetails.color && (
//                   <div>
//                     <label className='block text-sm font-semibold mb-2' style={{ color: colors.text }}>
//                       Color
//                     </label>
//                     <div className='flex flex-wrap gap-2'>
//                       {parseOptions(dataDetails.color).map((colorOption) => (
//                         <button
//                           key={colorOption}
//                           type='button'
//                           onClick={() => handleOptionSelect('color', colorOption)}
//                           className={`px-4 py-2 rounded-lg font-medium transition-all ${
//                             selectedOptions.color === colorOption 
//                               ? 'text-white' 
//                               : 'hover:scale-105'
//                           }`}
//                           style={{
//                             backgroundColor: selectedOptions.color === colorOption 
//                               ? colors.primary 
//                               : colors.bgSecondary,
//                             color: selectedOptions.color === colorOption 
//                               ? 'white' 
//                               : colors.text,
//                             border: `2px solid ${selectedOptions.color === colorOption 
//                               ? colors.primary 
//                               : colors.border}`
//                           }}
//                         >
//                           {colorOption}
//                           {selectedOptions.color === colorOption && (
//                             <Check size={16} className='inline ml-1' />
//                           )}
//                         </button>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {/* RAM Options */}
//                 {dataDetails.ram && (
//                   <div>
//                     <label className='block text-sm font-semibold mb-2' style={{ color: colors.text }}>
//                       RAM
//                     </label>
//                     <div className='flex flex-wrap gap-2'>
//                       {parseOptions(dataDetails.ram).map((ramOption) => (
//                         <button
//                           key={ramOption}
//                           type='button'
//                           onClick={() => handleOptionSelect('ram', ramOption)}
//                           className={`px-4 py-2 rounded-lg font-medium transition-all ${
//                             selectedOptions.ram === ramOption 
//                               ? 'text-white' 
//                               : 'hover:scale-105'
//                           }`}
//                           style={{
//                             backgroundColor: selectedOptions.ram === ramOption 
//                               ? colors.primary 
//                               : colors.bgSecondary,
//                             color: selectedOptions.ram === ramOption 
//                               ? 'white' 
//                               : colors.text,
//                             border: `2px solid ${selectedOptions.ram === ramOption 
//                               ? colors.primary 
//                               : colors.border}`
//                           }}
//                         >
//                           {ramOption}
//                           {selectedOptions.ram === ramOption && (
//                             <Check size={16} className='inline ml-1' />
//                           )}
//                         </button>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {/* Processor Options */}
//                 {dataDetails.processor && (
//                   <div>
//                     <label className='block text-sm font-semibold mb-2' style={{ color: colors.text }}>
//                       Processor
//                     </label>
//                     <div className='flex flex-wrap gap-2'>
//                       {parseOptions(dataDetails.processor).map((processorOption) => (
//                         <button
//                           key={processorOption}
//                           type='button'
//                           onClick={() => handleOptionSelect('processor', processorOption)}
//                           className={`px-4 py-2 rounded-lg font-medium transition-all ${
//                             selectedOptions.processor === processorOption 
//                               ? 'text-white' 
//                               : 'hover:scale-105'
//                           }`}
//                           style={{
//                             backgroundColor: selectedOptions.processor === processorOption 
//                               ? colors.primary 
//                               : colors.bgSecondary,
//                             color: selectedOptions.processor === processorOption 
//                               ? 'white' 
//                               : colors.text,
//                             border: `2px solid ${selectedOptions.processor === processorOption 
//                               ? colors.primary 
//                               : colors.border}`
//                           }}
//                         >
//                           {processorOption}
//                           {selectedOptions.processor === processorOption && (
//                             <Check size={16} className='inline ml-1' />
//                           )}
//                         </button>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {/* Screen Size Options */}
//                 {dataDetails.screenSize && (
//                   <div>
//                     <label className='block text-sm font-semibold mb-2' style={{ color: colors.text }}>
//                       Screen Size
//                     </label>
//                     <div className='flex flex-wrap gap-2'>
//                       {parseOptions(dataDetails.screenSize).map((screenOption) => (
//                         <button
//                           key={screenOption}
//                           type='button'
//                           onClick={() => handleOptionSelect('screenSize', screenOption)}
//                           className={`px-4 py-2 rounded-lg font-medium transition-all ${
//                             selectedOptions.screenSize === screenOption 
//                               ? 'text-white' 
//                               : 'hover:scale-105'
//                           }`}
//                           style={{
//                             backgroundColor: selectedOptions.screenSize === screenOption 
//                               ? colors.primary 
//                               : colors.bgSecondary,
//                             color: selectedOptions.screenSize === screenOption 
//                               ? 'white' 
//                               : colors.text,
//                             border: `2px solid ${selectedOptions.screenSize === screenOption 
//                               ? colors.primary 
//                               : colors.border}`
//                           }}
//                         >
//                           {screenOption}
//                           {selectedOptions.screenSize === screenOption && (
//                             <Check size={16} className='inline ml-1' />
//                           )}
//                         </button>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </div>

//               {/* Price Section */}
//               <div className='flex items-center gap-4 my-4'>
//                 <div>
//                   <p 
//                     className='text-sm' 
//                     style={{ color: colors.textSecondary }}
//                   >
//                     Price
//                   </p>
//                   <p 
//                     className='text-3xl font-bold'
//                     style={{ color: colors.primary }}
//                   >
//                     {displayNGNCurrency(dataDetails?.productPrice)}
//                   </p>
//                 </div>
//                 {dataDetails?.productDiscount && (
//                   <div>
//                     <p 
//                       className='text-sm' 
//                       style={{ color: colors.textSecondary }}
//                     >
//                       Original
//                     </p>
//                     <p 
//                       className='text-xl line-through'
//                       style={{ color: colors.textSecondary }}
//                     >
//                       {displayNGNCurrency(dataDetails?.productDiscount)}
//                     </p>
//                     <p 
//                       className='text-sm font-bold'
//                       style={{ color: colors.accent }}
//                     >
//                       Save {discountPercentage}%
//                     </p>
//                   </div>
//                 )}
//               </div>

//               {/* Description */}
//               <div className='my-4'>
//                 <p 
//                   className='text-sm font-bold mb-2'
//                   style={{ color: colors.primary }}
//                 >
//                   Description
//                 </p>
//                 <p 
//                   className='text-sm leading-relaxed'
//                   style={{ color: colors.text }}
//                 >
//                   {dataDetails.productDescription}
//                 </p>
//               </div>

//               {/* Selected Options Summary */}
//               {Object.values(selectedOptions).some(value => value) && (
//                 <div className='p-4 rounded-lg' style={{ backgroundColor: colors.primaryLight }}>
//                   <p className='text-sm font-semibold mb-2' style={{ color: colors.primary }}>
//                     Selected Configuration:
//                   </p>
//                   <div className='flex flex-wrap gap-2 text-sm'>
//                     {Object.entries(selectedOptions).map(([key, value]) => (
//                       value && (
//                         <span 
//                           key={key}
//                           className='px-3 py-1 rounded-full font-medium'
//                           style={{
//                             backgroundColor: colors.primary,
//                             color: 'white'
//                           }}
//                         >
//                           {key}: {value}
//                         </span>
//                       )
//                     ))}
//                   </div>
//                 </div>
//               )}

//               {/* Action Buttons */}
//               <div className='flex flex-wrap gap-4'>
//                 <button
//                   onClick={handleBuyNow}
//                   disabled={!areAllOptionsSelected()}
//                   className='flex items-center gap-2 px-8 py-3 rounded-lg font-bold text-white transition-all hover:scale-105 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed'
//                   style={{
//                     background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 100%)`
//                   }}
//                 >
//                   <ShoppingCart size={20} />
//                   Buy Now
//                 </button>
//                 <button
//                   onClick={(e) => handleAddToCart(e, dataDetails?._id)}
//                   disabled={!areAllOptionsSelected()}
//                   className='flex items-center gap-2 px-8 py-3 rounded-lg font-bold transition-all hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed'
//                   style={{
//                     backgroundColor: colors.bgSecondary,
//                     color: colors.primary,
//                     border: `2px solid ${colors.primary}`
//                   }}
//                 >
//                   <ShoppingCart size={20} />
//                   Add to Cart
//                 </button>
//                 <button
//                   className='flex items-center gap-2 px-8 py-3 rounded-lg font-bold transition-all hover:scale-105'
//                   style={{
//                     backgroundColor: colors.bgSecondary,
//                     color: colors.accent,
//                     border: `2px solid ${colors.accent}`
//                   }}
//                 >
//                   <Heart size={20} />
//                   Wishlist
//                 </button>
//               </div>

//               {/* Selection Required Message */}
//               {!areAllOptionsSelected() && (
//                 <p className='text-sm' style={{ color: colors.accent }}>
//                   * Please select all available options before adding to cart
//                 </p>
//               )}
//             </div>
//           )}
//         </div>

//         {/* Recommended Products */}
//         {dataDetails.productsCategory && (
//           <CategoryProductDisplay productsCategory={dataDetails.productsCategory} heading={"Recommended Products"}/>
//         )}

//         {/* Review Section (unchanged) */}
//         <div 
//           className='mt-12 p-8 rounded-lg'
//           style={{
//             backgroundColor: colors.bgSecondary,
//             border: `1px solid ${colors.border}`
//           }}
//         >
//           <h3 
//             className='text-2xl font-bold mb-6 flex items-center gap-2'
//             style={{ color: colors.text }}
//           >
//             <MdOutlineRateReview /> Reviews ({reviews.length})
//           </h3>

//           {/* Review Form */}
//           <form onSubmit={editingReview ? handleUpdateReview : handleSubmitReview} className='mb-8 p-6 rounded-lg' style={{ backgroundColor: colors.bgTertiary }}>
//             <div className='flex flex-col gap-4'>
//               <div className='flex items-center gap-3'>
//                 <span 
//                   className='font-medium'
//                   style={{ color: colors.text }}
//                 >
//                   Your Rating:
//                 </span>
//                 <div 
//                   className='flex gap-1 rounded-full p-2'
//                   style={{
//                     background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 100%)`
//                   }}
//                 >
//                   {renderStarRating(rating, setRating)}
//                 </div>
//               </div>
//               <textarea
//                 value={review}
//                 onChange={(e) => setReview(e.target.value)}
//                 placeholder='Write your review here...'
//                 className='w-full p-3 rounded-lg outline-none'
//                 style={{
//                   backgroundColor: colors.bg,
//                   color: colors.text,
//                   border: `1px solid ${colors.border}`
//                 }}
//                 rows={4}
//               />
//               <div className='flex gap-3'>
//                 <button
//                   type='submit'
//                   className='px-6 py-2 rounded-lg font-bold text-white transition-all hover:scale-105'
//                   style={{
//                     background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 100%)`
//                   }}
//                 >
//                   {editingReview ? 'Update Review' : 'Submit Review'}
//                 </button>
//                 {editingReview && (
//                   <button
//                     type='button'
//                     onClick={() => {
//                       setEditingReview(null);
//                       setReview('');
//                       setRating(0);
//                     }}
//                     className='px-6 py-2 rounded-lg font-bold transition-all'
//                     style={{
//                       backgroundColor: colors.accent,
//                       color: 'white'
//                     }}
//                   >
//                     Cancel
//                   </button>
//                 )}
//               </div>
//             </div>
//           </form>

//           {/* Review List */}
//           {reviews.length > 0 ? (
//             <div className='space-y-4'>
//               {reviews.map(reviewItem => (
//                 <div
//                   key={reviewItem._id}
//                   className='p-4 rounded-lg relative'
//                   style={{
//                     backgroundColor: colors.bg,
//                     border: `1px solid ${colors.border}`
//                   }}
//                 >
//                   <div className='flex justify-between items-start mb-3'>
//                     <div className='flex gap-1'>
//                       {[...Array(5)].map((_, i) => (
//                         <FaStar 
//                           key={i}
//                           size={16}
//                           style={{ color: i < reviewItem.rating ? colors.accent : colors.border }}
//                         />
//                       ))}
//                     </div>
//                     <span 
//                       className='text-xs'
//                       style={{ color: colors.textSecondary }}
//                     >
//                       {new Date(reviewItem.createdAt).toLocaleDateString()}
//                     </span>
//                   </div>

//                   <p 
//                     className='mb-3'
//                     style={{ color: colors.text }}
//                   >
//                     {reviewItem.comment}
//                   </p>

//                   {/* User-specific review actions */}
//                   {currentUser && (currentUser._id === reviewItem.userId) && (
//                     <div className='flex gap-3 items-center'>
//                       <div className='flex items-center gap-2 text-sm'>
//                         {currentUser.profilePic && (
//                           <img
//                             src={currentUser.profilePic}
//                             alt={currentUser.firstName}
//                             className='w-6 h-6 rounded-full object-cover'
//                           />
//                         )}
//                         <span style={{ color: colors.text }}>
//                           {currentUser.firstName}
//                         </span>
//                       </div>
//                       <button
//                         onClick={() => startEditReview(reviewItem)}
//                         className='p-2 rounded transition-all hover:scale-110'
//                         style={{
//                           color: colors.primary,
//                           backgroundColor: colors.primaryLight
//                         }}
//                         title="Edit review"
//                       >
//                         <FaEdit size={14} />
//                       </button>
//                       <button
//                         onClick={() => handleDeleteReview(reviewItem._id)}
//                         className='p-2 rounded transition-all hover:scale-110'
//                         style={{
//                           color: colors.accent,
//                           backgroundColor: `${colors.accent}20`
//                         }}
//                         title="Delete review"
//                       >
//                         <FaTrash size={14} />
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div 
//               className='text-center py-12 rounded-lg'
//               style={{
//                 backgroundColor: colors.bgTertiary,
//                 color: colors.textSecondary
//               }}
//             >
//               <MdOutlineRateReview size={32} className='mx-auto mb-3 opacity-50' />
//               <p>No reviews yet. Be the first to review this product!</p>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   )
// }

// export default ProductDetails





import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { summaryApi } from '../../common'
import { displayNGNCurrency } from '../../helpers/displayCurrency'
import { FaStar, FaRegStar, FaTrash, FaEdit } from "react-icons/fa";
import { MdOutlineRateReview } from "react-icons/md";
import { toast } from 'react-toastify';
import CategoryProductDisplay from '../../components/CategoryProductDisplay/CategoryProductDisplay';
import Context from '../../context';
import addToCart from '../../helpers/addToCart';
import { ShoppingCart, Heart, Star, Check } from 'lucide-react';
import { authFetch } from 'helpers/authFetch';

function ProductDetails() {
  const [dataDetails, setDataDetails] = useState({
    productName: "",
    productPrice: "",
    productsCategory: "",
    productDescription: "",
    productImage: [],
    productBrand: "",
    productDiscount: "",
    storage: "",
    color: "",
    ram: "",
    processor: "",
    screenSize: ""
  })

  const params = useParams()
  const [loading, setLoading] = useState(false);
  const [activeImage, setActiveImage] = useState("")
  const [review, setReview] = useState("");
  const [rating, setRating] = useState(0);
  const [reviews, setReviews] = useState([]);
  const [editingReview, setEditingReview] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [isZoomed, setIsZoomed] = useState(false);
  const [zoomOpen, setZoomOpen] = useState(false)
  const [zoomImage, setZoomImage] = useState({
    x: 0,
    y: 0
  })

  const [selectedOptions, setSelectedOptions] = useState({
    storage: '',
    color: '',
    ram: '',
    processor: '',
    screenSize: ''
  })

  const { fetchUserAddToCart } = useContext(Context)
  const navigate = useNavigate()

  const productImageListLoading = new Array(4).fill(null)

  const fetchCurrentUser = async () => {
    try {
      const response = await authFetch(summaryApi.current_user.url, {
        method: summaryApi.current_user.method,
        
      });
      const data = await response.json();
      setCurrentUser(data?.data);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  }

  const fetchProductDetails = async () => {
    setLoading(true)
    const response = await authFetch(`${summaryApi.productDetails.url}/${params?.id}`, {
      method: summaryApi.productDetails.method,
      
      headers: {
        'Content-Type': 'application/json',
      },
    })
    setLoading(false)
    const responseData = await response.json()

    setDataDetails(responseData.data)
    setActiveImage(responseData.data.productImage[0])
    
    if (responseData.data) {
      setSelectedOptions({
        storage: responseData.data.storage || '',
        color: responseData.data.color || '',
        ram: responseData.data.ram || '',
        processor: responseData.data.processor || '',
        screenSize: responseData.data.screenSize || ''
      })
    }
  }

  const fetchProductReviews = async () => {
    try {
      const response = await authFetch(`${summaryApi.getReviews.url}/${params?.id}`, {
        method: summaryApi.getReviews.method,
        
      });
      const data = await response.json();
      setReviews(data.data || []);
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      await fetchProductDetails();
      await fetchProductReviews();
      await fetchCurrentUser();
    };
    fetchData();
  }, [params.id]);

  const handleImageHover = (image) => {
    setActiveImage(image)
  }

  const handleOptionSelect = (optionType, value) => {
    setSelectedOptions(prev => ({
      ...prev,
      [optionType]: value
    }))
  }

  const parseOptions = (value) => {
    if (!value) return [];
    return value.split(',').map(item => item.trim()).filter(item => item);
  }

  const handleSubmitReview = async (e) => {
    e.preventDefault();
    if (review.trim() && rating > 0) {
      try {
        const reviewData = {
          rating: rating,
          comment: review
        };

        const response = await authFetch(`${summaryApi.postReview.url}/${params?.id}`, {
          method: summaryApi.postReview.method,
          
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(reviewData)
        });

        const responseText = await response.text();

        try {
          const data = JSON.parse(responseText);
          if (data.success) {
            fetchProductReviews();
            setReview("");
            setRating(0);
            toast.success(data.message)
          } else {
            toast.error(data.message || "Failed to post review");
          }
        } catch (parseError) {
          console.error("Error parsing response:", parseError);
          toast.error("Error processing server response");
        }
      } catch (error) {
        console.error("Error posting review:", error);
        toast.error("Failed to submit review");
      }
    }
  }

  const startEditReview = (review) => {
    setEditingReview(review);
    setReview(review.comment);
    setRating(review.rating);
  }

  const handleUpdateReview = async (e) => {
    e.preventDefault();
    if (review.trim() && rating > 0) {
      try {
        const updateData = {
          reviewId: editingReview._id,
          userId: currentUser._id,
          rating: rating,
          comment: review
        };

        const response = await authFetch(`${summaryApi.updateReview.url}/${params.id}`, {
          method: summaryApi.updateReview.method,
          
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updateData)
        });

        const data = await response.json();
        if (data.success) {
          fetchProductReviews();
          setReview("");
          setRating(0);
          setEditingReview(null);
          toast.success('Review updated successfully');
        }
      } catch (error) {
        console.error("Error updating review:", error);
        toast.error('Failed to update review');
      }
    }
  }

  const handleDeleteReview = async (reviewId) => {
    try {
      const deleteData = {
        reviewId: reviewId,
        userId: currentUser._id
      };

      const response = await authFetch(`${summaryApi.deleteReview.url}/${params.id}`, {
        method: summaryApi.deleteReview.method,
        
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(deleteData)
      });

      const data = await response.json();
      if (data.success) {
        fetchProductReviews();
        toast.success('Review deleted successfully');
      }
    } catch (error) {
      console.error("Error deleting review:", error);
      toast.error('Failed to delete review');
    }
  }

  const renderStarRating = (currentRating, setRatingFunc) => {
    return [1, 2, 3, 4, 5].map((star) => (
      <span
        key={star}
        onClick={() => setRatingFunc(star)}
        className="cursor-pointer text-xl transition-transform hover:scale-110"
        style={{ color: star <= currentRating ? '#1a365d' : '#cbd5e0' }}
      >
        {star <= currentRating ? <FaStar /> : <FaRegStar />}
      </span>
    ));
  }

  const handleZoomEnter = () => {
    setZoomOpen(true);
    setIsZoomed(true);
  };
  
  const handleZoomLeave = () => {
    setZoomOpen(false);
    setIsZoomed(false);
    setZoomImage({ x: 0, y: 0 });
  };
  
  const handleImageClick = () => {
    setZoomOpen(prev => !prev);
  };

  const handleZoomImage = useCallback((e) => {
    if (!isZoomed) return;

    const { left, top, width, height } = e.target.getBoundingClientRect();

    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    setZoomImage({
      x,
      y
    });
  }, [isZoomed]);

  const handleAddToCart = (e, productId) => {
    const cartData = {
        productId: productId,
        storage: selectedOptions.storage,
        color: selectedOptions.color,
        ram: selectedOptions.ram,
        processor: selectedOptions.processor,
        screenSize: selectedOptions.screenSize
    };
    
    addToCart(e, cartData, fetchUserAddToCart);
  }

  const handleBuyNow = async (e) => {  
    const cartData = {
        productId: dataDetails?._id,
        storage: selectedOptions.storage,
        color: selectedOptions.color,
        ram: selectedOptions.ram,
        processor: selectedOptions.processor,
        screenSize: selectedOptions.screenSize
    };
    
    await addToCart(e, cartData, fetchUserAddToCart);  
    navigate("/cart");
  }

  const discountPercentage = Math.round((dataDetails.productDiscount / dataDetails.productPrice) * 100);
  const averageRating = reviews.length > 0 
    ? (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1)
    : 0;

  const areAllOptionsSelected = () => {
    const availableOptions = [
      { field: 'storage', value: dataDetails.storage },
      { field: 'color', value: dataDetails.color },
      { field: 'ram', value: dataDetails.ram },
      { field: 'processor', value: dataDetails.processor },
      { field: 'screenSize', value: dataDetails.screenSize }
    ].filter(option => option.value && option.value.trim() !== '');

    return availableOptions.every(option => selectedOptions[option.field]);
  }

  return (
    <div className='min-h-screen bg-neutral-50 mt-[-45px]' style={{ fontFamily: 'Georgia, serif' }}>
      {/* Main Product Section - Full width on desktop */}
      <div className='max-w-screen-2xl mx-auto px-4 lg:px-8 py-8'>
        <div className='min-h-[calc(100vh-160px)] flex flex-col lg:flex-row gap-8 lg:gap-16'>
          {/* Product Image Section - Wider on desktop */}
          <div className='lg:w-1/2 flex flex-col lg:flex-row-reverse gap-6'>
            {/* Main Image - Larger on desktop */}
            <div 
              className='relative h-[500px] lg:h-[600px] w-full lg:w-[600px] flex items-center justify-center overflow-hidden bg-neutral-100 border border-neutral-300'
            >
              {loading ? (
                <div className='animate-pulse w-full h-full bg-neutral-200'></div>
              ) : (
                <img
                  src={activeImage}
                  alt={dataDetails.productName}
                  className='h-full w-full object-scale-down p-8'
                  onMouseEnter={handleZoomEnter}
                  onMouseLeave={handleZoomLeave}
                  onMouseMove={handleZoomImage}
                  onClick={handleImageClick}
                />
              )}
              
              {zoomOpen && (
                <div
                  className='hidden lg:block absolute min-w-[500px] min-h-[500px] overflow-hidden p-1 -right-[520px] top-0 bg-neutral-100 border border-neutral-300'
                >
                  <div
                    className='w-full h-full min-h-[500px] min-w-[500px] scale-150'
                    style={{
                      backgroundImage: `url(${activeImage})`,
                      backgroundSize: 'cover',
                      backgroundPosition: `${zoomImage.x}% ${zoomImage.y}%`,
                      backgroundRepeat: 'no-repeat'
                    }}
                  />
                </div>
              )}
            </div>

            {/* Thumbnail Images - Taller on desktop */}
            <div className='h-full'>
              {loading ? (
                <div className='flex gap-3 lg:flex-col overflow-x-auto lg:overflow-y-auto scrollbar-none h-full max-h-[500px]'>
                  {productImageListLoading.map((_, index) => (
                    <div
                      key={index}
                      className='h-24 w-24 lg:h-28 lg:w-28 animate-pulse bg-neutral-200 flex-shrink-0'
                    />
                  ))}
                </div>
              ) : (
                <div className='flex gap-3 lg:flex-col overflow-x-auto lg:overflow-y-auto scrollbar-none h-full max-h-[500px]'>
                  {dataDetails?.productImage?.map((item, index) => (
                    <div
                      key={index}
                      className='h-24 w-24 lg:h-28 lg:w-28 p-2 cursor-pointer transition-all hover:scale-105 flex-shrink-0'
                      style={{ 
                        backgroundColor: activeImage === item ? '#f5f5f5' : '#fafafa',
                        border: `2px solid ${activeImage === item ? '#1a365d' : '#d4d4d4'}`
                      }}
                    >
                      <img
                        src={item}
                        alt={dataDetails.productName}
                        onMouseEnter={() => handleImageHover(item)}
                        onClick={() => handleImageHover(item)}
                        className='h-full w-full object-scale-down'
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Product Details Section - Wider on desktop */}
          <div className='lg:w-1/2 flex flex-col gap-6'>
            {loading ? (
              <div className='flex flex-col gap-6 w-full'>
                {[...Array(5)].map((_, i) => (
                  <div 
                    key={i}
                    className='h-8 animate-pulse bg-neutral-200'
                  />
                ))}
              </div>
            ) : (
              <>
                {/* Brand Badge */}
                <div
                  className='inline-block px-5 py-2.5 w-fit text-sm font-medium tracking-widest uppercase bg-neutral-100 text-slate-800 border border-neutral-300'
                  style={{ fontFamily: 'Georgia, serif' }}
                >
                  Brand: {dataDetails?.productBrand}
                </div>

                {/* Product Name - Larger on desktop */}
                <h1 
                  className='text-3xl lg:text-4xl font-normal text-neutral-900 tracking-tight'
                  style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                >
                  {dataDetails?.productName}
                </h1>

                {/* Category */}
                <p 
                  className='text-sm capitalize text-neutral-600 tracking-wide'
                  style={{ fontFamily: 'Georgia, serif' }}
                >
                  Category: {dataDetails?.productsCategory}
                </p>

                {/* Rating - Larger on desktop */}
                <div className='flex items-center gap-4'>
                  <div className='flex gap-1'>
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        size={22}
                        fill={i < Math.floor(averageRating) ? '#1a365d' : '#d4d4d4'}
                        style={{ color: i < Math.floor(averageRating) ? '#1a365d' : '#d4d4d4' }}
                      />
                    ))}
                  </div>
                  <span className='text-sm text-neutral-600' style={{ fontFamily: 'Georgia, serif' }}>
                    ({averageRating}/5) • {reviews.length} reviews
                  </span>
                </div>

                {/* Product Specifications Selection - More spacious */}
                <div className='space-y-6 my-4'>
                  {/* Storage Options */}
                  {dataDetails.storage && (
                    <div>
                      <label className='block text-sm font-medium mb-3 text-neutral-900 tracking-wider uppercase' style={{ fontFamily: 'Georgia, serif' }}>
                        Storage
                      </label>
                      <div className='flex flex-wrap gap-3'>
                        {parseOptions(dataDetails.storage).map((storageOption) => (
                          <button
                            key={storageOption}
                            type='button'
                            onClick={() => handleOptionSelect('storage', storageOption)}
                            className={`px-5 py-3 font-medium transition-all text-sm tracking-wide ${
                              selectedOptions.storage === storageOption 
                                ? 'text-neutral-200' 
                                : 'hover:scale-[1.02]'
                            }`}
                            style={{
                              backgroundColor: selectedOptions.storage === storageOption 
                                ? '#1a365d' 
                                : '#fafafa',
                              color: selectedOptions.storage === storageOption 
                                ? '#f5f5f5' 
                                : '#171717',
                              border: `2px solid ${selectedOptions.storage === storageOption 
                                ? '#1a365d' 
                                : '#d4d4d4'}`,
                              fontFamily: 'Georgia, serif'
                            }}
                          >
                            {storageOption}
                            {selectedOptions.storage === storageOption && (
                              <Check size={16} className='inline ml-2' />
                            )}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Color Options */}
                  {dataDetails.color && (
                    <div>
                      <label className='block text-sm font-medium mb-3 text-neutral-900 tracking-wider uppercase' style={{ fontFamily: 'Georgia, serif' }}>
                        Color
                      </label>
                      <div className='flex flex-wrap gap-3'>
                        {parseOptions(dataDetails.color).map((colorOption) => (
                          <button
                            key={colorOption}
                            type='button'
                            onClick={() => handleOptionSelect('color', colorOption)}
                            className={`px-5 py-3 font-medium transition-all text-sm tracking-wide ${
                              selectedOptions.color === colorOption 
                                ? 'text-neutral-200' 
                                : 'hover:scale-[1.02]'
                            }`}
                            style={{
                              backgroundColor: selectedOptions.color === colorOption 
                                ? '#1a365d' 
                                : '#fafafa',
                              color: selectedOptions.color === colorOption 
                                ? '#f5f5f5' 
                                : '#171717',
                              border: `2px solid ${selectedOptions.color === colorOption 
                                ? '#1a365d' 
                                : '#d4d4d4'}`,
                              fontFamily: 'Georgia, serif'
                            }}
                          >
                            {colorOption}
                            {selectedOptions.color === colorOption && (
                              <Check size={16} className='inline ml-2' />
                            )}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* RAM Options */}
                  {dataDetails.ram && (
                    <div>
                      <label className='block text-sm font-medium mb-3 text-neutral-900 tracking-wider uppercase' style={{ fontFamily: 'Georgia, serif' }}>
                        RAM
                      </label>
                      <div className='flex flex-wrap gap-3'>
                        {parseOptions(dataDetails.ram).map((ramOption) => (
                          <button
                            key={ramOption}
                            type='button'
                            onClick={() => handleOptionSelect('ram', ramOption)}
                            className={`px-5 py-3 font-medium transition-all text-sm tracking-wide ${
                              selectedOptions.ram === ramOption 
                                ? 'text-neutral-200' 
                                : 'hover:scale-[1.02]'
                            }`}
                            style={{
                              backgroundColor: selectedOptions.ram === ramOption 
                                ? '#1a365d' 
                                : '#fafafa',
                              color: selectedOptions.ram === ramOption 
                                ? '#f5f5f5' 
                                : '#171717',
                              border: `2px solid ${selectedOptions.ram === ramOption 
                                ? '#1a365d' 
                                : '#d4d4d4'}`,
                              fontFamily: 'Georgia, serif'
                            }}
                          >
                            {ramOption}
                            {selectedOptions.ram === ramOption && (
                              <Check size={16} className='inline ml-2' />
                            )}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Processor Options */}
                  {dataDetails.processor && (
                    <div>
                      <label className='block text-sm font-medium mb-3 text-neutral-900 tracking-wider uppercase' style={{ fontFamily: 'Georgia, serif' }}>
                        Processor
                      </label>
                      <div className='flex flex-wrap gap-3'>
                        {parseOptions(dataDetails.processor).map((processorOption) => (
                          <button
                            key={processorOption}
                            type='button'
                            onClick={() => handleOptionSelect('processor', processorOption)}
                            className={`px-5 py-3 font-medium transition-all text-sm tracking-wide ${
                              selectedOptions.processor === processorOption 
                                ? 'text-neutral-200' 
                                : 'hover:scale-[1.02]'
                            }`}
                            style={{
                              backgroundColor: selectedOptions.processor === processorOption 
                                ? '#1a365d' 
                                : '#fafafa',
                              color: selectedOptions.processor === processorOption 
                                ? '#f5f5f5' 
                                : '#171717',
                              border: `2px solid ${selectedOptions.processor === processorOption 
                                ? '#1a365d' 
                                : '#d4d4d4'}`,
                              fontFamily: 'Georgia, serif'
                            }}
                          >
                            {processorOption}
                            {selectedOptions.processor === processorOption && (
                              <Check size={16} className='inline ml-2' />
                            )}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Screen Size Options */}
                  {dataDetails.screenSize && (
                    <div>
                      <label className='block text-sm font-medium mb-3 text-neutral-900 tracking-wider uppercase' style={{ fontFamily: 'Georgia, serif' }}>
                        Screen Size
                      </label>
                      <div className='flex flex-wrap gap-3'>
                        {parseOptions(dataDetails.screenSize).map((screenOption) => (
                          <button
                            key={screenOption}
                            type='button'
                            onClick={() => handleOptionSelect('screenSize', screenOption)}
                            className={`px-5 py-3 font-medium transition-all text-sm tracking-wide ${
                              selectedOptions.screenSize === screenOption 
                                ? 'text-neutral-200' 
                                : 'hover:scale-[1.02]'
                            }`}
                            style={{
                              backgroundColor: selectedOptions.screenSize === screenOption 
                                ? '#1a365d' 
                                : '#fafafa',
                              color: selectedOptions.screenSize === screenOption 
                                ? '#f5f5f5' 
                                : '#171717',
                              border: `2px solid ${selectedOptions.screenSize === screenOption 
                                ? '#1a365d' 
                                : '#d4d4d4'}`,
                              fontFamily: 'Georgia, serif'
                            }}
                          >
                            {screenOption}
                            {selectedOptions.screenSize === screenOption && (
                              <Check size={16} className='inline ml-2' />
                            )}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* Price Section - Larger on desktop */}
                <div className='flex items-center gap-6 my-6'>
                  <div>
                    <p 
                      className='text-sm tracking-wide text-neutral-600'
                      style={{ fontFamily: 'Georgia, serif' }}
                    >
                      Price
                    </p>
                    <p 
                      className='text-3xl font-normal text-slate-800'
                      style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                    >
                      {displayNGNCurrency(dataDetails?.productPrice)}
                    </p>
                  </div>
                  {dataDetails?.productDiscount && (
                    <div>
                      <p 
                        className='text-sm tracking-wide text-neutral-600'
                        style={{ fontFamily: 'Georgia, serif' }}
                      >
                        Discounted
                      </p>
                      <p 
                        className='text-xl line-through text-neutral-500'
                        style={{ fontFamily: 'Georgia, serif' }}
                      >
                        {displayNGNCurrency(dataDetails?.productDiscount)}
                      </p>
                      <p 
                        className='text-sm font-medium text-red-700'
                        style={{ fontFamily: 'Georgia, serif' }}
                      >
                        Save {discountPercentage}%
                      </p>
                    </div>
                  )}
                </div>

                {/* Description - Larger text on desktop */}
                <div className='my-6'>
                  <p 
                    className='text-sm font-medium mb-3 text-slate-800 tracking-wider uppercase'
                    style={{ fontFamily: 'Georgia, serif' }}
                  >
                    Description
                  </p>
                  <p 
                    className='text-base leading-relaxed text-neutral-700'
                    style={{ fontFamily: 'Georgia, serif' }}
                  >
                    {dataDetails.productDescription}
                  </p>
                </div>

                {/* Selected Options Summary */}
                {Object.values(selectedOptions).some(value => value) && (
                  <div className='p-6 bg-neutral-100 border border-neutral-300'>
                    <p className='text-sm font-medium mb-3 text-slate-800 tracking-wider uppercase' style={{ fontFamily: 'Georgia, serif' }}>
                      Selected Configuration:
                    </p>
                    <div className='flex flex-wrap gap-3 text-sm'>
                      {Object.entries(selectedOptions).map(([key, value]) => (
                        value && (
                          <span 
                            key={key}
                            className='px-4 py-2 font-medium bg-slate-800 text-neutral-200'
                            style={{ fontFamily: 'Georgia, serif' }}
                          >
                            {key}: {value}
                          </span>
                        )
                      ))}
                    </div>
                  </div>
                )}

                {/* Action Buttons - Larger on desktop */}
                <div className='flex flex-wrap gap-6 mt-8'>
                  <button
                    onClick={handleBuyNow}
                    disabled={!areAllOptionsSelected()}
                    className='flex items-center gap-3 px-10 py-4 font-medium text-sm uppercase tracking-wider text-neutral-200 transition-all hover:scale-[1.02] hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed bg-slate-800 border border-slate-800'
                    style={{ fontFamily: 'Georgia, serif' }}
                  >
                    <ShoppingCart size={20} />
                    Buy Now
                  </button>
                  <button
                    onClick={(e) => handleAddToCart(e, dataDetails?._id)}
                    disabled={!areAllOptionsSelected()}
                    className='flex items-center gap-3 px-10 py-4 font-medium text-sm uppercase tracking-wider transition-all hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed bg-transparent text-slate-800 border-2 border-slate-300'
                    style={{ fontFamily: 'Georgia, serif' }}
                  >
                    <ShoppingCart size={20} />
                    Add to Cart
                  </button>
                  <button
                    className='flex items-center gap-3 px-10 py-4 font-medium text-sm uppercase tracking-wider transition-all hover:scale-[1.02] bg-transparent text-red-700 border-2 border-red-700'
                    style={{ fontFamily: 'Georgia, serif' }}
                  >
                    <Heart size={20} />
                    Wishlist
                  </button>
                </div>

                {/* Selection Required Message */}
                {!areAllOptionsSelected() && (
                  <p className='text-sm text-red-700' style={{ fontFamily: 'Georgia, serif' }}>
                    * Please select all available options before adding to cart
                  </p>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Recommended Products - Full width section */}
      {dataDetails.productsCategory && (
        <div className='max-w-screen-2xl mx-auto px-4 lg:px-8 py-8'>
          <CategoryProductDisplay productsCategory={dataDetails.productsCategory} heading={"Recommended Products"}/>
        </div>
      )}

      {/* Review Section - Full width */}
      <div className='max-w-screen-2xl mx-auto px-4 lg:px-8 py-8'>
        <div 
          className='p-8 lg:p-12 bg-neutral-100 border border-neutral-300'
        >
          <h3 
            className='text-2xl font-normal mb-8 flex items-center gap-3 text-neutral-900 tracking-tight'
            style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
          >
            <MdOutlineRateReview size={28} /> Reviews ({reviews.length})
          </h3>

          {/* Review Form */}
          <form onSubmit={editingReview ? handleUpdateReview : handleSubmitReview} className='mb-10 p-8 bg-neutral-50 border border-neutral-200'>
            <div className='flex flex-col gap-6'>
              <div className='flex items-center gap-4'>
                <span 
                  className='font-medium text-sm tracking-wide text-neutral-900'
                  style={{ fontFamily: 'Georgia, serif' }}
                >
                  Your Rating:
                </span>
                <div 
                  className='flex gap-2 p-3 bg-slate-800'
                >
                  {renderStarRating(rating, setRating)}
                </div>
              </div>
              <textarea
                value={review}
                onChange={(e) => setReview(e.target.value)}
                placeholder='Write your review here...'
                className='w-full p-4 outline-none text-base bg-white text-neutral-900 border border-neutral-300'
                style={{ fontFamily: 'Georgia, serif' }}
                rows={5}
              />
              <div className='flex gap-4'>
                <button
                  type='submit'
                  className='px-8 py-3 font-medium text-sm uppercase tracking-wider text-neutral-200 transition-all hover:scale-[1.02] bg-slate-800'
                  style={{ fontFamily: 'Georgia, serif' }}
                >
                  {editingReview ? 'Update Review' : 'Submit Review'}
                </button>
                {editingReview && (
                  <button
                    type='button'
                    onClick={() => {
                      setEditingReview(null);
                      setReview('');
                      setRating(0);
                    }}
                    className='px-8 py-3 font-medium text-sm uppercase tracking-wider transition-all bg-red-700 text-neutral-200'
                    style={{ fontFamily: 'Georgia, serif' }}
                  >
                    Cancel
                  </button>
                )}
              </div>
            </div>
          </form>

          {/* Review List */}
          {reviews.length > 0 ? (
            <div className='space-y-6'>
              {reviews.map(reviewItem => (
                <div
                  key={reviewItem._id}
                  className='p-6 relative bg-white border border-neutral-300'
                >
                  <div className='flex justify-between items-start mb-4'>
                    <div className='flex gap-2'>
                      {[...Array(5)].map((_, i) => (
                        <FaStar 
                          key={i}
                          size={18}
                          style={{ color: i < reviewItem.rating ? '#1a365d' : '#d4d4d4' }}
                        />
                      ))}
                    </div>
                    <span 
                      className='text-sm text-neutral-500'
                      style={{ fontFamily: 'Georgia, serif' }}
                    >
                      {new Date(reviewItem.createdAt).toLocaleDateString()}
                    </span>
                  </div>

                  <p 
                    className='mb-4 text-base text-neutral-700'
                    style={{ fontFamily: 'Georgia, serif' }}
                  >
                    {reviewItem.comment}
                  </p>

                  {currentUser && (currentUser._id === reviewItem.userId) && (
                    <div className='flex gap-4 items-center'>
                      <div className='flex items-center gap-3 text-sm'>
                        {currentUser.profilePic && (
                          <img
                            src={currentUser.profilePic}
                            alt={currentUser.firstName}
                            className='w-8 h-8 rounded-full object-cover'
                          />
                        )}
                        <span style={{ color: '#171717', fontFamily: 'Georgia, serif' }}>
                          {currentUser.firstName}
                        </span>
                      </div>
                      <button
                        onClick={() => startEditReview(reviewItem)}
                        className='p-2.5 transition-all hover:scale-110 text-slate-800 bg-neutral-100 border border-neutral-300'
                        title="Edit review"
                      >
                        <FaEdit size={15} />
                      </button>
                      <button
                        onClick={() => handleDeleteReview(reviewItem._id)}
                        className='p-2.5 transition-all hover:scale-110 text-red-700 bg-red-50 border border-red-200'
                        title="Delete review"
                      >
                        <FaTrash size={15} />
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div 
              className='text-center py-16 bg-neutral-50 text-neutral-500 border border-neutral-200'
            >
              <MdOutlineRateReview size={40} className='mx-auto mb-4 opacity-50' />
              <p style={{ fontFamily: 'Georgia, serif', fontSize: '16px' }}>No reviews yet. Be the first to review this product!</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ProductDetails